import {includes, isNumber, isString} from 'lodash';
import {NormalizerI} from './normalizer.i';
import {FloatNormalizer} from "./float.normalizer";
import {Injectable} from "@angular/core";

const DOT = '.';
const EMPTY = '';
const digitsReg = /[^0-9]/g;

@Injectable()
export class MoneyNormalizer extends FloatNormalizer implements NormalizerI {
    /**
     * Normalizer for money
     * @param value
     * @returns {string}
     * Input value example: sdg24.532dfs.32
     * Output value example: 24532.32
     */
    normalize(value: string): string {
        var digits: string = super.normalize(value);

        if (!isString(digits)) {
            if (isNumber(digits)) {
                value = Number(digits).toString();
            } else {
                return EMPTY;
            }
        }

        if (includes(digits, DOT)) {
            return digits.substr(0, digits.indexOf(DOT) + 3);
        } else {
            return digits;
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/money.normalizer.ts